export enum EmailQueueApi {
  EMAIL_QUEUE = '/api/v1.0/emails/unsent',
  CANCEL_EMAILS = '/api/v1.0/emails/cancel',
  CANCEL_ALL_EMAILS = '/api/v1.0/emails/cancelforuser'
}
